export interface UserModel {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  metadata: {
    createdAt: string;
    updatedAt: string;
  };
  payment?: {
    stripe?: {
      customerId: string;
    };
  };
  isActive?: boolean;
  preferences?: UserPreferencesModel;
}

export interface UserPreferencesModel {
  language?: string;
}

export interface PostUserModel {
  _id?: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  metadata: {
    createdAt: string;
    updatedAt: string;
  };
  payment?: {
    stripe?: {
      customerId: string;
    };
  };
}

export interface UserRoleModel {
  roleKey: string;
  resourceType: string;
  initial: boolean;
}

export interface UserBillingAddressModel {
  line1: string;
  city: string;
  state: string;
  postal_code: string;
  country: string;
}

export interface SetupIntentResult {
  client_secret: string;
  customer: string;
}
